import { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { Pencil, Trash2 } from 'lucide-react';
import "../../Styles/yellowcalfcss/IncomeType.css";

export function IncomeType () {
  const [recordsList, setRecordsList] = useState([
    { id: 1, typeName: 'current', createdDate: '2022-03-29', accountName: 'akbarshan' },
    { id: 2, typeName: 'savings', createdDate: '2024-05-08', accountName: 'akbar' },
    { id: 3, typeName: 'savings', createdDate: '2024-05-08', accountName: 'akbar' },
    { id: 4, typeName: 'savings', createdDate: '2024-05-08', accountName: 'akbar' },
    { id: 5, typeName: 'savings', createdDate: '2024-05-08', accountName: 'akbar' },
  ]);

  const [displayModal, setDisplayModal] = useState(false);
  const [currentEditingRecord, setCurrentEditingRecord] = useState(null);
  const [formTypeName, setFormTypeName] = useState('');
  const [formAccountName, setFormAccountName] = useState('');

  const handleCreateNew = () => {
    setCurrentEditingRecord(null);
    setFormTypeName('');
    setFormAccountName('');
    setDisplayModal(true);
  };

  const handleEditRecord = (record) => {
    setCurrentEditingRecord(record);
    setFormTypeName(record.typeName);
    setFormAccountName(record.accountName);
    setDisplayModal(true);
  };

  const handleDeleteRecord = (id) => {
    setRecordsList(recordsList.filter(record => record.id !== id));
  };

  const handleSaveRecord = () => {
    if (currentEditingRecord) {
      setRecordsList(recordsList.map(record => 
        record.id === currentEditingRecord.id 
          ? { ...record, typeName: formTypeName, accountName: formAccountName }
          : record
      ));
    } else {
      const newRecord = {
        id: Math.max(...recordsList.map(r => r.id), 0) + 1,
        typeName: formTypeName,
        createdDate: new Date().toISOString().split('T')[0],
        accountName: formAccountName,
      };
      setRecordsList([...recordsList, newRecord]);
    }
    setDisplayModal(false);
  };

  const handleExportData = () => {
    console.log('Exporting data:', recordsList);
   
  };

  return (
   
        <div className="income-type-container">
      <div className="top-header-section">
        <h1 className="page-title-text">Income Type</h1>
        <div className="action-buttons-group">
          <Button className="create-new-button" onClick={handleCreateNew}>
            Create Income Type
          </Button>
          <Button className="export-data-button" onClick={handleExportData}>
            Export
          </Button>
        </div>
      </div>

      <div className="content-table-section">
        <div className="search-filter-panel">
          <div className="filter-column-number"></div>
          <div className="filter-column-typename">
            <Form.Control type="text" className="search-input-box" />
          </div>
          <div className="filter-column-datevalue">
            <Form.Control type="text" className="search-input-box" />
          </div>   
        </div>



             
        <div className="table-headers-row">
          <div className="header-cell-serial">Sr.No</div>
          <div className="header-cell-name">Name</div>
          <div className="header-cell-date">Created Date</div>
          <div className="header-cell-account">Account Name</div>
          <div className="header-cell-actions">Actions</div>
        </div>

        <div className="records-display-area">
          {recordsList.map((record) => (
            <div key={record.id} className="single-record-line">
              <div className="field-number-value">{record.id}</div>
              <div className="field-typename-value">{record.typeName}</div>
              <div className="field-datevalue-text">{record.createdDate}</div>
              <div className="field-accountvalue-text">{record.accountName}</div>
              <div className="field-buttons-group">
                <button 
                  className="modify-icon-control" 
                  onClick={() => handleEditRecord(record)}
                >
                  <Pencil size={16} />
                </button>
                <button 
                  className="remove-icon-control" 
                  onClick={() => handleDeleteRecord(record.id)}
                >
                  <Trash2 size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="summary-status-bar">
          Showing 1-{recordsList.length} of {recordsList.length} items.
        </div>
      </div>

      <Modal show={displayModal} onHide={() => setDisplayModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{currentEditingRecord ? 'Edit Income Type' : 'Create Income Type'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Type Name</Form.Label>
              <Form.Control 
                type="text" 
                value={formTypeName}
                onChange={(e) => setFormTypeName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Account Name</Form.Label>
              <Form.Control 
                type="text" 
                value={formAccountName}
                onChange={(e) => setFormAccountName(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDisplayModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveRecord}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
